/**
 * Validates Step 2 fields. All required.
 * Returns object of field keys to error messages (empty string if valid).
 */
export function validateStep2(values) {
  const errors = {};

  const beDomain = (values.beDomain ?? "").toString().trim();
  if (!beDomain) errors.beDomain = "Povinné pole.";

  const frontendType = (values.frontendType ?? "").toString().trim();
  if (!frontendType) errors.frontendType = "Povinné pole.";

  const businessPartner = (values.businessPartner ?? "").toString().trim();
  if (!businessPartner) errors.businessPartner = "Povinné pole.";

  const servicePartner = (values.servicePartner ?? "").toString().trim();
  // "none" (Žiadny) is a valid explicit selection; only empty is invalid
  if (!servicePartner) errors.servicePartner = "Povinné pole.";

  const typLicencie = (values.typLicencie ?? "").toString().trim();
  if (!typLicencie) errors.typLicencie = "Povinné pole.";

  const relationsTypZakaznika = (values.relationsTypZakaznika ?? "").toString().trim();
  if (!relationsTypZakaznika) errors.relationsTypZakaznika = "Povinné pole.";

  const posIntegracia = (values.posIntegracia ?? "").toString().trim();
  // "none" (Žiadna) is a valid explicit selection; only empty is invalid
  if (!posIntegracia) errors.posIntegracia = "Povinné pole.";

  return errors;
}
